export default __webpack_public_path__ + "static/bridal-edit-banner-mobile-6712cc3cd0f348dd21209edc60c1a6a0.webp";